import { IComboBoxOption } from "@fluentui/react";
import { IDataTableColumnSchema } from "../../types/IDataTableColumn";

export interface IDataTableColumnProps {
    schema: IDataTableColumnSchema;
}

export class DataTableColumn {

    __props: IDataTableColumnProps;

    constructor(props: IDataTableColumnProps) {
        this.__props = props;
    }

    get id(): string {
        return this.__props.schema.id;
    }

    get attributeId(): string {
        return this.__props.schema.attributeId;
    }

    get fieldId(): string {
        return this.__props.schema.fieldId;
    }

    get headerText(): string {
        return this.__props.schema.headerText;
    }

    toComboBoxOption(): IComboBoxOption {
        return {
            key: this.fieldId,
            text: this.headerText
        }
    }

}